import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Subscriber {
  id: string;
  email: string;
  lang: 'nl' | 'en';
  source: string;
  brevo_contact_id: number | null;
  subscribed_at: string;
  unsubscribed_at: string | null;
}

const db = supabase as unknown as {
  from: (table: string) => any;
};

export function useSubscribers() {
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    const { data, error } = await db
      .from('newsletter_subscribers')
      .select('*')
      .order('subscribed_at', { ascending: false });

    if (error) {
      setError(error.message);
    } else {
      setSubscribers(data ?? []);
      setError(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { subscribers, loading, error, reload: load };
}
